import { css, mediaQueries } from '@eti/styles';
import { Inline } from '@etg/wings';
import type { TicketV5Props } from '../../model';
import { TicketCardV5 } from '../cards/TicketCardV5';

const ticketsWrapperStyles = css`
  align-items: center;
  background-color: #fff;
  border-radius: 0;
  bottom: 0;
  box-shadow: 0 -2px 8px 0 #0000000d;
  left: 0;
  padding: 16px;
  position: absolute;
  width: 100%;
  z-index: 10;

  @media ${mediaQueries.small.only} {
    flex-direction: column;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const TicketV5 = ({
  isLoading,
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  onClick,
  tickets,
  selectedTicketType,
  ticketPriceModalInfo,
}: TicketV5Props) => {
  const isMultipleTickets = tickets?.length > 1;

  return (
    <Inline className={ticketsWrapperStyles} data-testid="ticket-version-5" noWrap spacing={8}>
      {tickets?.map((ticket, index) => (
        <TicketCardV5
          index={index}
          isLoading={isLoading}
          isMultipleTickets={isMultipleTickets}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          key={ticket.ticketType}
          onClick={onClick}
          selectedTicketType={selectedTicketType}
          ticket={ticket}
          ticketPriceModalInfo={ticketPriceModalInfo}
        />
      ))}
    </Inline>
  );
};
